import React from 'react'

/**
 * DEFAULT BUTTON
 * @param {{Icon?: React.Component, label: string, description?: string, classIcon?: string}} props 
 * @returns {JSX.Element}
 */
function DefaultBtn({ Icon, label, description = '', classIcon = '', ...rest }) {
  return (
    <>
      {description ? <div className="tooltip" data-tip={description}>
        <button
          className='rounded-full group inline-flex space-x-2 text-gray-500 hover:text-white hover:bg-general-teal items-center py-1.5 px-3 border-2 hover:border-gray-300 font-medium text-sm leading-5 disabled:text-gray-500 disabled:bg-gray-200 disabled:cursor-not-allowed transition-colors'
          {...rest}
        >
          {Icon && <Icon className={'w-5 h-5 ' + classIcon} />}
          <span>{label}</span>
        </button>
      </div> : <button
        className='rounded-full group inline-flex space-x-2 text-gray-500 hover:text-white hover:bg-general-teal items-center py-1.5 px-3 border-2 hover:border-gray-300 font-medium text-sm leading-5 disabled:text-gray-500 disabled:bg-gray-200 disabled:cursor-not-allowed transition-colors'
        {...rest}
      >
        {Icon && <Icon className={'w-5 h-5 ' + classIcon} />}
        <span>{label}</span>
      </button>}
    </>
  )
}

export default DefaultBtn